module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fine-uploader"
  }, [_c('div', {
    staticClass: "grid grid--no-collapse-large"
  }, [_c('div', {
    staticClass: "grid__item grid__item--6"
  }, [_c('form', {
    ref: "form"
  }, [_c('label', {
    class: {
      'fine-uploader__box': true,
      'is-dragging': _vm.opts.dragging,
    },
    on: {
      "dragstart": function($event) {
        $event.preventDefault();
        return _vm.onDragEnter($event)
      },
      "dragenter": function($event) {
        $event.preventDefault();
        return _vm.onDragEnter($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.onDragEnter($event)
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDragDrop($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        return _vm.onDragLeave($event)
      },
      "dragend": function($event) {
        $event.preventDefault();
        return _vm.onDragLeave($event)
      }
    }
  }, [_c('input', {
    ref: "upload",
    attrs: {
      "type": "file",
      "accept": _vm.options.options.validation.acceptFiles,
      "multiple": _vm.options.options.multiple
    },
    on: {
      "change": _vm.onUploadDoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fine-uploader__box__icon"
  }, [_c('icon', {
    attrs: {
      "name": "cloud-upload",
      "width": "60",
      "height": "56"
    }
  }), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "uploader.dropOrClick",
      "tag": "p"
    }
  }, [_c('span', {
    attrs: {
      "place": "type"
    }
  }, [_vm._v(_vm._s(_vm.type == 'imageUpload' ? 'image' : 'documents'))]), _vm._v(" "), _c('br', {
    attrs: {
      "place": "br"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--6"
  }, [_c('div', {
    staticClass: "fine-uploader__image-placeholder"
  }, [(!_vm.state.hidden) ? [_c('div', {
    staticClass: "loader loader--absolute"
  }, [_c('div', {
    staticClass: "loader__icon"
  }), _vm._v(" "), (!_vm.state.hideProgressBar) ? _c('div', {
    staticClass: "loader__progress"
  }, [_c('div', {
    staticClass: "loader__progress__bar",
    style: (("width: " + _vm.percentWidth + "%;"))
  })]) : _vm._e()])] : [(_vm.type === 'documentUpload') ? [(_vm.submittedFiles.length == 0) ? [_c('icon', {
    attrs: {
      "name": "file-o",
      "height": "60",
      "width": "60"
    }
  })] : _vm._l((_vm.submittedFiles), function(file) {
    return [_c('div', {
      staticClass: "fine-uploader__item"
    }, [_c('span', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('a', {
      attrs: {
        "data-id": file.id
      },
      on: {
        "click": _vm.removeFile
      }
    }, [_vm._v("remove")])])]
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'imageUpload') ? [(!_vm.uploadedImage) ? [_c('icon', {
    attrs: {
      "name": "file-picture-o",
      "height": "60",
      "width": "60"
    }
  })] : [_c('img', {
    attrs: {
      "src": ("https://docs-cdn.signable.co.uk/signatures/" + _vm.uploadedImage)
    }
  })]] : _vm._e()], _vm._v(" "), (_vm.state.error) ? _c('message', {
    attrs: {
      "type": "error",
      "iconName": "life-ring"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.state.errorMessage) + "\n        ")]) : _vm._e()], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1a97728","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FineUploader.vue
// module id = 1060
// module chunks = 1